import React from "react";
import Modal from "components/ui/Modal";
import { getIcon } from "utils/iconsConfig";
import { fetchWipDepartmentDesignInfo } from "features/clients/wip/Api";
import { useQuery } from "@tanstack/react-query";

const ViewMessageModal = ({ open, onClose, data }) => {
  // console.log('data in viewMessage===>>>', data)
  const {
    data: wipData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["wipDepartmentDesignInfo", data?.orderNo],
    queryFn: () => fetchWipDepartmentDesignInfo(data?.orderNo),
    enabled: !!data?.orderNo && open,
  });


  if (isLoading) {
    return (
      <Modal open={open} handleClose={onClose}>
        <div style={{ padding: "20px" }}>Loading...</div>
      </Modal>
    );
  }

  if (isError) {
    return (
      <Modal open={open} handleClose={onClose}>
        <div style={{ padding: "20px" }}>Error fetching data!</div>
      </Modal>
    );
  }

  const bagDetail = wipData?.BagDetail?.[0] ?? {};

  const messageData = {
    heading: `${bagDetail?.BagBarcode || data?.styleNo || ""} messages`,
    sections: {
      remarks: {
        content: bagDetail?.SpecialRemarks || data?.SpecialRemarks,
      },
      stampInstruction: {
        content: bagDetail?.StampInstruction || data?.StampInstruction,
      },
      customerInstruction: {
        content: bagDetail?.CustomerProductionInstruction || data?.CustomerProductionInstruction,
      },
      designProductInstruction: {
        content: bagDetail?.DesignProductionInstruction || data?.DesignProductionInstruction,
      },
    },
  };

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
        width: "638px",
      }}
    >
      <div>
        {/* ---------- Header ---------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontWeight: 500,
              fontSize: "20px",
              color: "#000000",
              lineHeight: "100%",
              fontFamily: "Poppins",
            }}
          >
            {messageData.heading}
          </span>
        </div>

        <hr style={{ margin: "16px 0", borderColor: "#ddd" }} />

        {/* ---------- Remarks Section ---------- */}
        <MessageSection title="Remarks" content={messageData.sections.remarks.content} />

        {/* ---------- Stamp Instruction Section ---------- */}
        <MessageSection title="Stamp Instruction" content={messageData.sections.stampInstruction.content} />

        {/* ---------- Customer Instruction Section ---------- */}
        <MessageSection title="Customer Instruction" content={messageData.sections.customerInstruction.content} />

        {/* ---------- Design Product Instruction Section ---------- */}
        <MessageSection title="Design Product Instruction" content={messageData.sections.designProductInstruction.content} />
      </div>
    </Modal>
  );
};

//  Message Component
const MessageSection = ({ title, content }) => (
  <div style={{ marginBottom: "18px" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontWeight: 600,
        fontSize: "16px",
        color: "#4D4D4D",
        marginBottom: "6px",
        fontFamily: "Poppins",
        lineHeight: "22px",
        letterSpacing: "-0.41px",
      }}
    >
      {title}
    </div>
    <div
      style={{
        borderRadius: "10px",
        padding: "16px",
        // minHeight: "80px",
        color: "#101010",
        lineHeight: "22px",
        fontSize: "20px",
        fontFamily: "Karla",
        background: "#EDEDEB",
        fontWeight: 400,
        letterSpacing: "-0.41px",
        height: "fit-content",
      }}
    >
      {content}
    </div>
  </div>
);

export default ViewMessageModal;
